class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add("animate", "active");
      const cartDrawerItems = this.querySelector("cart-drawer-items");
      if (cartDrawerItems) {
        cartDrawerItems.updateCartUpsellToggleState();
        cartDrawerItems.updateCartUpsellVisibility();
      }
      document.dispatchEvent(new CustomEvent('cart:open'));
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

/* ===== PestShield — prix barré + badge "Selling out fast" ===== */
(function () {
  var PRODUCT_KEY = "pestshield";

  var COMPARE = {
    "58510842233206": 8390,
    "58510859075958": 16790,
    "58510859108726": 25190,
    "58510859141494": 33590
  };

  var PRICE = {
    "58510842233206": 4195,
    "58510859075958": 8395,
    "58510859108726": 12595,
    "58510859141494": 16795
  };

  function money(cents) {
    return "AU$" + (cents / 100).toFixed(2);
  }

  function variantIdFrom(row) {
    var link = row.querySelector('a[href*="/products/"]');
    if (link) {
      var m = link.getAttribute("href").match(/[?&]variant=(\d+)/);
      if (m) return m[1];
    }
    var qty = row.querySelector("[data-quantity-variant-id]");
    if (qty) return qty.getAttribute("data-quantity-variant-id");
    var input = row.querySelector('input[name="updates[]"]');
    if (input && input.id) {
      var m2 = input.id.match(/(\d{10,})/);
      if (m2) return m2[1];
    }
    return null;
  }

  function decorate() {
    var scope = document.getElementById("CartDrawer") || document;
    var rows = scope.querySelectorAll(".cart-item");

    Array.prototype.forEach.call(rows, function (row) {
      var link = row.querySelector('a[href*="/products/"]');
      if (!link) return;
      if (link.getAttribute("href").toLowerCase().indexOf(PRODUCT_KEY) === -1) return;

      var vid = variantIdFrom(row);
      if (!vid || !COMPARE[vid]) return;

      var qtyInput = row.querySelector('input[name="updates[]"], .quantity__input');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      var badPill = row.querySelector(
        ".cart-item__discounted-prices, .product-option--discount, ul.discounts, .cart-discounts, .discounts"
      );
      if (badPill) badPill.style.display = "none";

      var wrap =
        row.querySelector(".cart-item__price-wrapper") ||
        row.querySelector(".cart-item__totals") ||
        row.querySelector(".cart-item__prices");

      if (wrap) {
        var old = wrap.querySelector(".psx-price");
        if (old) old.remove();

        Array.prototype.forEach.call(wrap.children, function (c) {
          if (!c.classList.contains("psx-price")) c.style.display = "none";
        });

        var box = document.createElement("div");
        box.className = "psx-price";
        box.innerHTML =
          '<span class="psx-was">' + money(COMPARE[vid] * qty) + "</span>" +
          '<span class="psx-now">' + money(PRICE[vid] * qty) + "</span>";
        wrap.appendChild(box);
      }

      var nameEl = row.querySelector(".cart-item__name");
      var details =
        row.querySelector(".cart-item__details") ||
        (nameEl ? nameEl.parentNode : null);

      if (details && !details.querySelector(".psx-sof")) {
        var b = document.createElement("div");
        b.className = "psx-sof";
        b.innerHTML = '<span class="psx-sof__dot"></span>Selling out fast';
        details.appendChild(b);
      }
    });
  }

  var css = document.createElement("style");
  css.textContent =
    ".psx-price{display:flex;align-items:baseline;justify-content:flex-end;flex-wrap:wrap;gap:9px;line-height:1.2}" +
    ".psx-was{color:#9AA4B4;text-decoration:line-through;font-size:15px;font-weight:600}" +
    ".psx-now{color:#2B6BF0;font-size:17px;font-weight:700}" +
    ".psx-sof{display:inline-flex;align-items:center;gap:7px;margin:9px 0 2px;padding:6px 14px;background:#FDECEC;border-radius:99px;font-size:13.5px;font-weight:600;color:#E03131;line-height:1.2}" +
    ".psx-sof__dot{width:7px;height:7px;border-radius:50%;background:#E03131;display:block;flex:0 0 auto}" +
    "@media (max-width:600px){.psx-price{justify-content:flex-start}.psx-now{font-size:16px}}";
  document.head.appendChild(css);

  var _render = CartDrawer.prototype.renderContents;
  CartDrawer.prototype.renderContents = function (state) {
    _render.call(this, state);
    setTimeout(decorate, 80);
  };

  var _open = CartDrawer.prototype.open;
  CartDrawer.prototype.open = function (t) {
    _open.call(this, t);
    setTimeout(decorate, 80);
  };

  document.addEventListener("cart:open", function () {
    setTimeout(decorate, 80);
  });

  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(decorate, 300);
    var d = document.querySelector("cart-drawer");
    if (d && window.MutationObserver) {
      new MutationObserver(function () {
        setTimeout(decorate, 60);
      }).observe(d, { childList: true, subtree: true });
    }
  });

  setTimeout(decorate, 600);
})();